import Component from './Component'

export default class Timer extends Component {

	static _type = 'Timer'

	_timer

	constructor (params) {
        super(params)

		// Default parameters
        this.params = Object.assign({
            callback: null,
            interval: 1000
        }, this.params)
    }

	tether () {
		super.tether()

        this._timer = setInterval(this.tick.bind(this), this.params.interval)
	}

    destroy() {

		// Stop the timer
        if (this._timer !== null) {
			clearInterval(this._timer)
			this._timer = null
		}

        super.destroy()
    }

    tick() {

		// Call the callback function
		if (this.params.callback) {
			this.params.callback()
		}
    }
}
